import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { BaseFileAction } from '@iris/modules/dms/components/file-actions/base-file-action';
import { TranslatePipe } from '@ngx-translate/core';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-edit-office-file-button',
  imports: [
    NgClass,
    TranslatePipe,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './dms-edit-office-file-button.component.html',
  styleUrls: ['./dms-edit-office-file-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsEditOfficeFileButtonComponent extends BaseFileAction {
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);
  readonly label = 'label.dms.OpenInMicrosoftOfficeOnline';

  readonly fileDisbaled = computed(() => {
    const disabled = this.isFolderLocked() || this.disabled || !this.isOfficeEditableDocument;
    this.setDisabled(disabled);
    return disabled;
  });

  get isOfficeEditableDocument(): boolean {
    return this.dmsFilesSandbox.isFileEditable(this.file());
  }

  get tooltip(): string {
    return this.iconOnly ? this.title : 'text.dms.OfficeOnly';
  }

  openEditOfficeUrl(): void {
    this.dmsModalsSandbox.showOfficeEditorModal(this.file());
  }
}
